<script setup>
import TextInput from '@/components/TextInput.vue';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import api from "@/libs/api.js";

const router = useRouter();
const errors = ref({});

const form = ref({
    phone: '',
    password: '',
    remember: true,
});

const submit = () => {
    api.post('app/login', form.value).then((res) => {
        localStorage.setItem('token', res.data.token);
        router.push({ name: 'dashboard' });
    }).catch((error) => {
        if (error.response.status === 422) {
            errors.value = error.response.data.errors;
        }
    })
};

</script>

<template>
    <div class="w-full overflow-hidden h-dvh flex  justify-center items-center py-4 px-8 bg-white dark:text-white dark:bg-white">
        <div class="w-full max-w-md">
            <h1 class="text-3xl font-bold text-gray-800 dark:text-white ">Đăng nhập</h1>
            <p class="mt-2 ">Nhận thông báo hóa đơn, và các tiện ích hỗ trợ quá trình thuê</p>
            <div class="divide-y divide-gray-200">
                <div class="py-8 text-base text-gray-700 sm:text-lg sm:leading-7">
                    <div class="mb-4">
                        <TextInput label="Số điện thoại" id="phone" type="text" inputmode="numeric" pattern="[0-9]*" v-model="form.phone" :errors="errors.phone" />
                    </div>
                    <div class="mb-4">
                        <TextInput label="Mật khẩu" id="password" type="password" v-model="form.password" :errors="errors.password" />
                    </div>
                    <div class="w-full mb-4 flex justify-end">
                        <router-link :to="{ name: 'forgot-password' }" class="float-right font-semibold text-green-600 dark:text-gray-400">
                            Quên mật khẩu?
                        </router-link>
                    </div>
                    <div class="relative w-full text-center ">
                        <button type="button" @click.prevent="submit"
                            class="w-full py-3 text-xl bg-green-600 text-white rounded-md cursor-pointer">
                            Đăng nhập
                        </button>
                    </div>
                    <div class="w-full relative pt-4 ">
                        <p class="flex justify-center items-center gap-1 ">
                            <span class="dark:text-gray-400">
                                Bạn chưa có tài khoản?
                                <router-link :to="{ name: 'register' }"
                                    class="font-semibold text-green-600 dark:text-gray-400">
                                    Đăng ký ngay
                                </router-link>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.transform_transition {
    animation: transform 1s ease-out;
}

@keyframes transform {
    0% {
        transform: translateY(-100%);
        opacity: 0;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}
</style>
